import { takeLatest, put, call } from 'redux-saga/effects';
import * as TypeActions from '../store/nsirMapa/actionsTypes';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import BaseService from '../services/BaseService';

const buildFilter = (filter) => ({ possuiCoordenadas: true, ...(filter || {}) });

function postNsirsMapa(filter) {
  return BaseService.post({ url: 'nsirs/mapa/filter', data: filter });
}

function* loadNsirsMapa(action) {
  const filter = buildFilter(action.filter);

  try {
    const nsirsResponse = yield call(postNsirsMapa, filter);
    yield put({ type: TypeActions.NSIR_MAPA_FIND_SUCCESS, data: nsirsResponse.data });
  } catch (error) {
    yield put({ type: TypeActions.NSIR_MAPA_FIND_SUCCESS, data: [] });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar o mapa de NSIRs.',
    });
  }
}

export function* watchNsirMapa() {
  yield takeLatest(TypeActions.NSIR_MAPA_LOAD_COMPLETO, loadNsirsMapa);
}
